<template>
  <el-dialog
    :visible="visible"
    :show-close="false"
    width="60%"
    top="5vh"
    class="edit-detail-dialog"
    center
    @close="handleDialogClose"
    :close-on-click-modal="false">
    <span slot="title" class="title-container">
      <span class="title-text">{{factoryName + $t('factoryLabelPrint.templateContentEditing')}}</span>
      <img
        src="@/assets/close.png"
        class="close-image"
        @click="close"
      />
    </span>
    <el-form class="el-form" :model="form" ref="refForm" :rules="rules" label-width="120px">
      <el-form-item label-width="0">
        <el-col :span="11">
          <el-form-item label="P/N:" prop="partNo">
            <el-input
              v-model.trim="form.partNo"
              name="partNo"
              type="text"
              autocomplete="on"
              clearable
              size="small"
              maxlength="64"
            />
          </el-form-item>
        </el-col>
        <el-col :span="11">
          <el-form-item label="Lot No:" prop="lotNo">
            <el-input
              v-model.trim="form.lotNo"
              name="lotNo"
              type="text"
              autocomplete="on"
              clearable
              size="small"
              maxlength="64"
            />
          </el-form-item>
        </el-col>
      </el-form-item>
      <el-form-item label-width="0">
        <el-col :span="11">
          <el-form-item label="QTY:" prop="qty">
            <el-input
              v-model.trim.number="form.qty"
              name="qty"
              type="text"
              autocomplete="on"
              clearable
              size="small"
              maxlength="9"
            />
          </el-form-item>
        </el-col>
        <el-col :span="11">
          <el-form-item label="WFR No:" prop="waferNo">
            <el-input
              v-model.trim="form.waferNo"
              name="waferNo"
              type="text"
              autocomplete="on"
              clearable
              size="small"
              maxlength="64"
            />
          </el-form-item>
        </el-col>
      </el-form-item>
      <el-form-item label-width="0">
        <el-col :span="11">
          <el-form-item label="NOTE:" prop="note">
            <el-input
              v-model="form.note"
              name="note"
              type="text"
              autocomplete="on"
              clearable
              size="small"
              maxlength="64"
            />
          </el-form-item>
        </el-col>
        <el-col :span="11">
          <el-form-item label="Prop:" prop="prop">
            <el-input
              v-model="form.prop"
              name="prop"
              type="text"
              autocomplete="on"
              clearable
              size="small"
              maxlength="64"
            />
          </el-form-item>
        </el-col>
      </el-form-item>
      <el-form-item label-width="0">
        <el-col :span="11">
          <el-form-item label="Type:" prop="type">
            <el-input
              v-model="form.type"
              name="type"
              type="text"
              autocomplete="on"
              clearable
              size="small"
              maxlength="64"
            />
          </el-form-item>
        </el-col>
        <el-col :span="11">
          <el-form-item label="Date:" prop="dateCode">
            <el-date-picker
              v-model="form.dateCode"
              type="date"
              size="small"
              style="width: 100%;">
            </el-date-picker>
          </el-form-item>
        </el-col>
      </el-form-item>
      <el-form-item label-width="0">
        <el-col :span="11">
          <el-form-item label="C/N:" prop="cn">
            <el-input
              v-model="form.cn"
              name="cn"
              type="text"
              autocomplete="on"
              clearable
              size="small"
              maxlength="64"
            />
          </el-form-item>
        </el-col>
        <el-col :span="11">
          <el-form-item label="Die:" prop="die">
            <el-input
              v-model.trim.number="form.die"
              name="die"
              type="text"
              autocomplete="on"
              clearable
              size="small"
              maxlength="9"
            />
          </el-form-item>
        </el-col>
      </el-form-item>
      <el-form-item :label="$t('common.stylePreview') + ':'" style="margin-bottom: 0">
      </el-form-item>
      <el-form-item>
        <el-col :span="15">
          <iframe
            id="historyLabelIFrameHuaLanLabelDialog"
            scrolling="no"
            width="520"
            height="260"
            frameborder="0"
            style="background: #E9E9E9;"
          ></iframe>
          <el-button style="position: absolute; margin-left: 10px;" size="small" @click="printClick">{{$t('common.print')}}</el-button>
        </el-col>
      </el-form-item>
    </el-form>
    <span slot="footer">
        <el-button size="small" @click="close">{{$t('common.cancel')}}</el-button>
        <el-button
          size="small"
          type="primary"
          @click="submitForm">
            {{$t('common.sure')}}
        </el-button>
      </span>
  </el-dialog>
</template>

<script>
  import moment from 'moment';
  import {
    validateCount,
    validateLotNo
  } from '@/utils/validate';
  import {
    initHuaLanLabelFrame,
    printFactoryLabel,
  } from '@/utils/factory-label';
  import {
    isValueEmpty,
    isNum,
    isPositiveNum
  } from '@/utils';
  import i18n from '@/lang';
  import {
    updateBox,
  } from '@/api/boxLabel';
  import {
    updateLabel,
  } from '@/api/label';

  export default {
    name: "HuaLanLabelDialog",
    props: {
      factoryName: {
        type: String,
        default: '',
      },
      visible: {
        type: Boolean,
        default: false,
      },
      editRow: {
        type: Object,
        default: () => {},
      },
      isBoxLabel: {
        type: Boolean,
        default: false,
      }
    },
    data() {
      return {
        form: {
          partNo: '',
          lotNo: '',
          qty: '',
          waferNo: '',
          note: '',
          prop: '',
          type: '',
          dateCode: '',
          cn: '',
          die: '',
        },
        rules: {
          partNo: [{
            required: true,
            trigger: 'blur',
            message: this.$t('factoryLabelPrint.partNoCanNotBeEmpty')
          }],
          lotNo: [{
            required: true,
            trigger: 'blur',
            validator: validateLotNo
          }],
          qty: [{
            required: true,
            trigger: 'blur',
            validator: validateCount
          }],
          dateCode: [{
            required: true,
            trigger: 'blur',
            message: this.$t('factoryLabelPrint.deliveryDateCanNotBeEmpty')
          }],
          die: [{
            required: true,
            trigger: 'blur',
            validator: validateCount
          }],
        },
      };
    },
    watch: {
      editRow(newValue) {
        if (newValue && Object.keys(newValue).length > 0 && this.visible === true) {
          const {
            id,
            partNo,
            lotNo,
            qty,
            customPartNo,
            reserve,
            marking,
            packageType,
            dateCode,
            purchaseOrderNo,
            processingOrderNo,
          } = newValue;
          this.form = {
            id,
            partNo: partNo,
            lotNo: lotNo,
            qty: qty,
            waferNo: customPartNo,
            note: reserve,
            prop: marking,
            type: packageType,
            dateCode: dateCode,
            cn: purchaseOrderNo,
            die: processingOrderNo,
          };
          setTimeout(() => {
            this.initHuaLanLabelFrame();
          }, 500);
        }
      }
    },
    methods: {
      handleDialogClose() {
        this.close();
      },
      close() {
        this.$emit('update:visible', false);
        this.$emit('close');
        if (this.$refs.refForm && typeof this.$refs.refForm.clearValidate === 'function') {
          this.$refs.refForm.clearValidate();
        }
      },
      submitForm() {
        this.$refs.refForm.validate(async (valid) => {
          if (valid) {
            if (this.isBoxLabel) {
              this.updateBox();
            } else {
              this.updateLabel();
            }
          }
        });
      },
      async updateBox() {
        const {
          id,
          partNo,
          lotNo,
          qty,
          waferNo,
          note,
          prop,
          type,
          dateCode,
          cn,
          die,
        } = this.form;
        this.loading = true;
        try {
          await updateBox({
            boxLabelId: id,
            partNo,
            lotNo,
            qty,
            customPartNo: waferNo,
            reserve: note,
            marking: prop,
            packageType: type,
            dateCode: moment(dateCode).format('YYYY-MM-DD'),
            purchaseOrderNo: cn,
            processingOrderNo: die,
          });
          this.$emit('update');
          this.close();
          this.$message({
            type: 'success',
            message: this.$t('common.updateSuccess'),
          });
        } catch (e) {
          // do nothing.
        } finally {
          this.loading = false;
        }
      },
      async updateLabel() {
        const {
          id,
          partNo,
          lotNo,
          qty,
          waferNo,
          note,
          prop,
          type,
          dateCode,
          cn,
          die,
        } = this.form;
        this.loading = true;
        try {
          await updateLabel({
            labelId: id,
            partNo,
            lotNo,
            qty,
            customPartNo: waferNo,
            reserve: note,
            marking: prop,
            packageType: type,
            dateCode: moment(dateCode).format('YYYY-MM-DD'),
            purchaseOrderNo: cn,
            processingOrderNo: die,
          });
          this.$emit('update');
          this.close();
          this.$message({
            type: 'success',
            message: this.$t('common.updateSuccess'),
          });
        } catch (e) {
          // do nothing.
        } finally {
          this.loading = false;
        }
      },
      initHuaLanLabelFrame() {
        const {
          partNo,
          lotNo,
          qty,
          waferNo,
          note,
          prop,
          type,
          dateCode,
          cn,
          die,
        } = this.form;
        let iframe = document.getElementById('historyLabelIFrameHuaLanLabelDialog');
        iframe = initHuaLanLabelFrame({
          iframe,
          partNo,
          lotNo,
          qty,
          waferNo,
          note,
          prop,
          type,
          dateCode,
          cn,
          die,
        });
        iframe.contentWindow.document.close();
      },
      printHuaLanLabelFrame() {
        const {
          partNo,
          lotNo,
          qty,
          waferNo,
          note,
          prop,
          type,
          dateCode,
          cn,
          die,
        } = this.form;
        let iframe = document.getElementById('historyLabelIFrameHuaLanLabelDialog');
        iframe = initHuaLanLabelFrame({
          iframe,
          partNo,
          lotNo,
          qty,
          waferNo,
          note,
          prop,
          type,
          dateCode,
          cn,
          die,
        });
        iframe.contentWindow.document.close();
        printFactoryLabel(iframe);
      },
      printClick() {
        let iframe = document.getElementById('historyLabelIFrameHuaLanLabelDialog');
        iframe.contentWindow.document.close();
        printFactoryLabel(iframe);
      }
    }
  }
</script>

<style scoped>
  .title-container {
    display: flex;
    display: -webkit-flex;
    flex-direction: row;
    justify-content: space-between;
    background: -webkit-linear-gradient(#F9F9F9, #EEEEEE);
    background: -o-linear-gradient(#F9F9F9, #EEEEEE);
    background: -moz-linear-gradient(#F9F9F9, #EEEEEE);
    background: linear-gradient(#F9F9F9, #EEEEEE);
    padding: 10px 15px;
    align-items: center;
  }

  .title-text {
    color: #404040;
    font-size: 16px;
  }

  .el-form {
    margin: 0 30px;
  }

  .close-image {
    width: 22px;
    height: 22px;
    cursor: pointer;
    padding: 0 10px;
  }
</style>
<style>
  .edit-detail-dialog .el-dialog__header {
    padding: 0;
  }
</style>
